import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { APP_VERSION } from '../../utils/config/version';

@Component({
    selector: 'acm-footer',
    imports: [],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
    @Input() appName = 'Aperture Credentials Manager';
    // Baked in at build time from the root package.json by the prebuild:version target.
    @Input() version = APP_VERSION;
}
